import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { SignedUrlObject } from '@shared/models';

import { MetricActionType, MetricModule, MetricType, Metrics } from '../models/metrics';
import {
  ReceiveOrderListResponse,
  ReceiveOrderListSearchCriteria,
  ReceiveOrderViewResponse
} from '../models/receive-order.model';
import { ReceiveOrderExceedReportExportCriteria } from '../models/report.model';
import { metricsReporting } from '../utils/metrics-util';
import { BaseService } from './base.service';

@Injectable()
export class ReceiveOrderService extends BaseService {
  public headers: HttpHeaders;

  constructor(private readonly http: HttpClient) {
    super();
    this.envService = this.env.services.receiveOrder;
    this.headers = new HttpHeaders(this.envService.headers);
  }

  public searchByCriteria(criteria: ReceiveOrderListSearchCriteria): Observable<ReceiveOrderListResponse> {
    const metricsReq: Metrics = {
      metrics: [
        {
          metricType: MetricType.RESPONSE_TIME,
          module: MetricModule.ORDER,
          route: this.envService.url,
          action: MetricActionType.SEARCH
        }
      ]
    };
    const params = this.getParams(criteria);
    return this.http.get<ReceiveOrderListResponse>(this.getUrl(), {
      headers: this.loaderHeaders(null, metricsReq),
      observe: 'body',
      params
    });
  }

  public getReceiveOrderByNo(receiveOrderNo: string): Observable<ReceiveOrderViewResponse> {
    const url = this.getFullUrl(this.envService.getByNo, { receiveOrderNo });
    return this.http.get<ReceiveOrderViewResponse>(url, {
      headers: this.headers,
      observe: 'body'
    });
  }

  public exceedExport(criteria: ReceiveOrderExceedReportExportCriteria): Observable<any> {
    const params = this.getParams(criteria, true);
    const url = this.getFullUrl(this.envService.exceedExport);
    const metrics = metricsReporting([this.envService.url, this.envService.exceedExport]);

    return this.http.get<any>(url, {
      headers: this.loaderHeaders(0, metrics),
      observe: 'body',
      params,
      responseType: 'blob' as 'json'
    });
  }

  printReceiveOrder(receiveOrderNo: string): Observable<any> {
    const url = this.getFullUrl(this.envService.print, { receiveOrderNo });
    return this.http.post<any>(url, null, {
      headers: this.loaderHeaders(0),
      responseType: 'blob' as 'json'
    });
  }

  getImage(receiveOrderNo: string, index: number): Observable<SignedUrlObject> {
    const url = this.getFullUrl(this.envService.images, { receiveOrderNo, index: index.toString() });
    return this.http.get<SignedUrlObject>(url, {
      headers: this.headers,
      observe: 'body'
    });
  }
}
